import { ref } from "firebase/database";
import { database } from "../../services/firebaseService/firebaseConfig";

const COMPANY_SETTINGS_PATH = "CompanySettings";

export const getCompanySettingsDocRef = (companyId: string) =>
  ref(database, `${COMPANY_SETTINGS_PATH}/${companyId}`);
